<template>
    <v-dialog v-model="show" width="500" persistent>
        <v-form ref="form" @submit.prevent="save">
            <v-card :loading="loading" :disabled="loading">
                <v-card-title>Редактор</v-card-title>
                <v-card-text>
                    <v-text-field :rules="req" v-model="name" label="Наименование" />
                    <v-text-field :rules="req" v-model="link" label="Ссылка" />
                    <v-checkbox label="Скрыта" v-model="hidden" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="error" text @click="close">Отмена</v-btn>
                    <v-btn color="primary" text type="submit">Сохранить</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template> 

<script>
export default {
    data: () => ({
        show: false,
        loading: false,
        name: '',
        link: '',
        hidden: false,
        id: 0,
    }),
    methods: {
        async open(id) {
            this.name = '';
            this.link = '';
            this.hidden = false;
            this.id = id;
            this.show = true;

            if (id) {
                this.loading = true;
                const { one } = await this.$api(`/admin/video-link/${id}`);
                
                this.name = one.name;
                this.link = one.link;
                this.hidden = one.hidden;

                this.loading = false;
            }
        },
        close() {
            this.show = false;
        },
        async save() {
            if (!this.$refs.form.validate()) {
                return;
            }

            let url = '/admin/video-link';
            if (this.id) {
                url += `/${this.id}`;
            }

            this.loading = true;
            const { one } = await this.$api(url, {
                method: this.id ? 'PATCH' : 'POST',
                body: {
                    name: this.name,
                    link: this.link,
                    hidden: this.hidden,
                },
            });
            this.$emit('saved', one);
            this.loading = false;
            this.close();
        },
    },
    computed: {
        req: () => [
            v => !!v || 'Введите значение'
        ],
    },
};
</script>
